export const ICON_SIZE_MAP = {
  large: 30,
  medium: 24,
  small: 20,
  smallavg: 17,
  smaller: 15,
  smallerx: 12,
  tiny: 6,
};
